import request from '../request.js'

// 获取菜单信息
const getTreeTablePageList = function (data) {
    return request({
        url: 'sysDict/getTreeTablePageList',
        method: 'post',
        data
    })
}

const getTreeTableList = function (data) {
    return request({
        url: 'sysDict/getTreeTableList',
        method: 'post',
        data
    })
}

const saveOrUpdate = function (data) {
    return request({
        url: 'sysDict/saveOrUpdate',
        method: 'post',
        data
    })
}

const getInfoById = function (data) {
    return request({
        url: 'sysDict/getInfoById',
        method: 'post',
        data
    })
}

const deleteById = function (data) {
    return request({
        url: 'sysDict/deleteById',
        method: 'post',
        data
    })
}

const getDictByParentValue = function (data) {
    return request({
        url: 'sysDict/getDictByParentValue',
        method: 'post',
        data
    })
}

const selectPageDicts = function (data) {
    return request({
        url: 'sysDict/selectPageDicts',
        method: 'post',
        data
    })
}

//获取所有字典（二级）
const selectAllDicts = function (data) {
    return request({
        url: 'sysDict/selectAllDicts',
        method: 'post',
        data
    })
}

//地区树结构-首页项目新增时用到
const getAllAreaTree = function (data) {
    return request({
        url: 'sysDict/getAllAreaTree',
        method: 'post',
        data
    })
}

export {
    deleteById,
    getInfoById,
    saveOrUpdate,
    getAllAreaTree,
    selectAllDicts,
    selectPageDicts,
    getTreeTableList,
    getTreeTablePageList,
    getDictByParentValue,
}
